import React, { useState, useEffect } from 'react';
import ParticipantsList from './ParticipantsList';
import { API_BASE } from '../api';

function ParticipantsPage() {
  const [participants, setParticipants] = useState([]);

  const fetchParticipants = async () => {
    try {
      const response = await fetch(`${API_BASE}/deelnemers`);
      if (response.ok) {
        const data = await response.json();
        const sorted = data.sort((a, b) => new Date(b.registratietijd) - new Date(a.registratietijd));
        setParticipants(sorted);
      }
    } catch (error) {
      console.error('An error occurred while fetching participants:', error);
    }
  };

  useEffect(() => {
    fetchParticipants();
    const id = setInterval(fetchParticipants, 5000);
    return () => clearInterval(id);
  }, []);

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete ${name}?`)) {
      try {
        const response = await fetch(`${API_BASE}/deelnemers/${id}`, {
          method: 'DELETE',
        });
        if (response.ok) {
          fetchParticipants();
        } else {
          console.error('Error deleting participant');
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    }
  };

  return <ParticipantsList participants={participants} onDelete={handleDelete} />;
}

export default ParticipantsPage;
